import React, { Component } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Icon,
  Typography,
  Button,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { generalDialogStyles, resourceFormStyle } from '../../css/style';

const styles = resourceFormStyle();
const dialogStyles = generalDialogStyles();

class TaxActionDialog extends Component {
  render() {
    const {
      confirmDialogOpen,
      onCloseDialog,
      taxActionDialogTitle,
      actionText,
      onConfirmDialogAction,
    } = this.props;
    return (
      <Dialog
        open={confirmDialogOpen}
        onClose={onCloseDialog}
      >
        <DialogContent style={dialogStyles.taxActionDialogContainer}>
          <IconButton
            style={styles.itemCusDialogCloseBtn}
            onClick={onCloseDialog}
          >
            <Icon>
              close
            </Icon>
          </IconButton>
          <Typography style={dialogStyles.taxActionDialogTitle}>
            {`${taxActionDialogTitle} this Tax`}
          </Typography>
          <Icon style={dialogStyles.taxActionDialogIcon}>
            warning
          </Icon>
          <Typography style={dialogStyles.taxActionDialogText}>
            {actionText}
          </Typography>
          <div style={dialogStyles.taxActionDialogButtonsContainer}>
            <Button
              variant='contained'
              style={styles.backTaxesButton}
              onClick={onCloseDialog}
            >
              Cancel
            </Button>
            <Button
              variant='contained'
              style={styles.saveTaxesButton}
              onClick={onConfirmDialogAction}
            >
              {taxActionDialogTitle}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}

TaxActionDialog.propTypes = {
  confirmDialogOpen: PropTypes.bool.isRequired,
  onCloseDialog: PropTypes.func.isRequired,
  taxActionDialogTitle: PropTypes.string,
  actionText: PropTypes.string,
  onConfirmDialogAction: PropTypes.func.isRequired,
};

TaxActionDialog.defaultProps = {
  taxActionDialogTitle: '',
  actionText: '',
};

export default TaxActionDialog;
